export const UPLOADS_PERMISSIONS = {
  read: 'uploads.read',
  create: 'uploads.create',
  update: 'uploads.update',
  delete: 'uploads.delete'
} as const;
